const magnitude = (maxY: number) => {
  const magnitude = Math.pow(10, Math.floor(Math.log10(maxY)))
  return magnitude * Math.floor(maxY / magnitude) + magnitude
}

export default magnitude
